import { useI18n } from 'i18n-utils'
import { PLATFORM_CONFIG } from 'platform-config'
import securityIcon from 'platform-config/src/assets/image/common/profile-security-bottom.png'
import './SecurityBottom.scss'

export const SecurityBottom = defineComponent({
  setup() {
    const { t } = useI18n()
    return () => (
      <div class="security-auth-bottom">
        <img width={16} src={securityIcon} alt="security-icon" />
        <span>
          {t('受{name}安全风控保护', {
            name: t(PLATFORM_CONFIG.platformName),
          })}
        </span>
      </div>
    )
  },
})
